<template>
  <div>
    <page-header title="Insights" ></page-header>
    <b-container>
      <b-card title="Attempted Calls" class="mb-3">
        <app-agent-calls-chart :data="agentCalls" v-if="agentCalls"></app-agent-calls-chart>
      </b-card>
      <b-card title="Outreach Status" class="mb-3">
        <app-outreach-status-chart :data="outreachStatus" v-if="outreachStatus"></app-outreach-status-chart>
      </b-card>
      <b-card title="Outreach Speed" class="mb-3">
        <app-outreach-speed-chart :data="outreachSpeed" v-if="outreachStatus"></app-outreach-speed-chart>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import PageHeader from '@/components/global/PageHeader';
import {AgentCalls, OutreachSpeed, OutreachStatus} from '@/gql/insights/insights.gql';
import AppAgentCallsChart from '@/components/insights/AgentCallsChart.vue';
import AppOutreachStatusChart from '@/components/insights/OutreachStatusChart.vue';
import AppOutreachSpeedChart from '@/components/insights/OutreachSpeedChart.vue';

export default {
  components: {
    PageHeader,
    AppAgentCallsChart,
    AppOutreachStatusChart,
    AppOutreachSpeedChart,
  },
  apollo: {
    agentCalls: {
      query: AgentCalls,
    },
    outreachSpeed: {
      query: OutreachSpeed,
    },
    outreachStatus: {
      query: OutreachStatus,
    },
  },
};
</script>
